module.exports = __webpack_public_path__ + "media/price_bot/supportLogo-33187491.png";